import { css } from 'emotion'

export const paddingSmallStyles = css`
  padding: 8px;
`
